import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ViewComponent, ViewOnlyType } from '../../../../core';

@Component({
  selector: 'app-quote-product-multi-select',
  templateUrl: './quote-product-multi-select.component.html',
  styleUrls: ['./quote-product-multi-select.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class QuoteProductMultiselectComponent extends ViewComponent {
  @Input() override dataList: ViewOnlyType[] = [];
}
